// --- debounce helper ---
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const later = () => {
      clearTimeout(timeout);
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

if (!customElements.get('collection-scroll-lg')) {
  class CollectionScroll extends HTMLElement {
    constructor() {
      super();
      this.viewport = this.querySelector('.theme-scroll--inner');
      this.slideWidth = 274;
      this.slidesToScroll = 1;

      // drag scroll vars
      this.isDown = false;
      this.startX = 0;
      this.scrollLeftStart = 0;
      this.moved = false; // para diferenciar click de drag
    }

    connectedCallback() {
      this.init();
      this.enableDragScroll();
    }

    init() {
      this.setSlides();
      this.reachedEnd = 0;

      if (this.slides.length < 1) {
        this.parentNode.style.display = 'none';
        return;
      }

      this.nav = this.querySelector('.theme-scroll-nav');
      this.navPrev = this.querySelector('.flickity-prev');
      this.navNext = this.querySelector('.flickity-next');

      this.resizeObserver = new ResizeObserver(() => {
        if (this.slides.length > 1) {
          this.slideWidth = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        }
        this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == this.viewport.scrollLeft;
        this.onNavDisabled();
      });

      this.debouncedOnScroll = debounce((event) => {
        this.onScroll(event);
      }, 100);

      this.setListeners();
      this.centerArrows();
    }

    setSlides() {
      this.slides = this.querySelectorAll('.carousel__slide');
      this.slidesLength = this.slides.length;
      this.lastSlide = this.slides[this.slides.length - 1];
    }

    setListeners() {
      if (this.nav) this.nav.addEventListener('click', this.onNavClick.bind(this));
      this.viewport.addEventListener('scroll', this.debouncedOnScroll.bind(this));
      this.viewport.addEventListener('resize', this.debouncedOnScroll.bind(this));
      if (this.slides[0]) this.resizeObserver.observe(this.slides[0]);
    }

    onScroll() {
      this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == Math.floor(this.viewport.scrollLeft);
      this.onNavDisabled();
    }

    onNavClick(e) {
      if (!e.target.matches('.flickity-nav') && !e.target.parentNode.matches('.flickity-nav')) {
        return;
      }

      if (e.target.name == 'next' || e.target.parentNode.name == 'next') {
        this.scrollPos = this.viewport.scrollLeft + this.slidesToScroll * this.slideWidth;
      } else if (e.target.name == 'prev' || e.target.parentNode.name == 'prev') {
        this.scrollPos = this.viewport.scrollLeft - this.slidesToScroll * this.slideWidth;
      }

      this.viewport.scrollTo({
        left: this.scrollPos,
        behavior: "smooth"
      });
    }

    onNavDisabled() {
      if (this.navPrev) {
        this.navPrev.disabled = this.viewport.scrollLeft === 0 ? 1 : 0;
      }
      if (this.navNext) {
        this.navNext.disabled = this.reachedEnd ? 1 : 0;
      }
    }

    centerArrows() {
      let first_cell = this.slides[0],
        max_height = 0,
        image_height = 0;
      if (first_cell?.querySelector('.product-card-image')) {
        image_height = first_cell.querySelector('.product-card-image').clientHeight;
      } else if (this.slides[1]?.querySelector('.product-card-image')) {
        image_height = this.slides[1].querySelector('.product-card-image').clientHeight;
      }
      if (image_height > 0) {
        this.slides.forEach((item) => {
          if (item.clientHeight > max_height) {
            max_height = item.clientHeight;
          }
        });

        if (max_height > image_height) {
          let difference = (max_height - image_height) / -2;
          if (this.navPrev) this.navPrev.style.transform = `translateY(${difference}px)`;
          if (this.navNext) this.navNext.style.transform = `translateY(${difference}px)`;
        }
      }
    }

    // --- Drag Scroll con prevención de click accidental ---
    enableDragScroll() {
      // Mouse
      this.viewport.addEventListener('mousedown', (e) => {
        if (e.target.tagName.toLowerCase() === 'a' || e.target.closest('a')) {
          e.preventDefault(); // evitar arrastre de enlace/imagen
        }
        this.isDown = true;
        this.moved = false;
        this.viewport.classList.add('is-dragging');
        this.startX = e.pageX - this.viewport.offsetLeft;
        this.scrollLeftStart = this.viewport.scrollLeft;
      });

      this.viewport.addEventListener('mouseleave', () => {
        this.isDown = false;
        this.viewport.classList.remove('is-dragging');
      });

      this.viewport.addEventListener('mouseup', (e) => {
        this.isDown = false;
        this.viewport.classList.remove('is-dragging');
        if (this.moved) {
          e.preventDefault(); // cancela click si fue drag
        }
      });

      this.viewport.addEventListener('mousemove', (e) => {
        if (!this.isDown) return;
        e.preventDefault();
        this.moved = true;
        const x = e.pageX - this.viewport.offsetLeft;
        const walk = (x - this.startX) * 1.2;
        this.viewport.scrollLeft = this.scrollLeftStart - walk;
      });

      // Touch
      this.viewport.addEventListener('touchstart', (e) => {
        if (e.target.tagName.toLowerCase() === 'a' || e.target.closest('a')) {
          e.preventDefault();
        }
        this.isDown = true;
        this.moved = false;
        this.startX = e.touches[0].pageX - this.viewport.offsetLeft;
        this.scrollLeftStart = this.viewport.scrollLeft;
      });

      this.viewport.addEventListener('touchend', (e) => {
        this.isDown = false;
        if (this.moved) {
          e.preventDefault();
        }
      });

      this.viewport.addEventListener('touchmove', (e) => {
        if (!this.isDown) return;
        this.moved = true;
        const x = e.touches[0].pageX - this.viewport.offsetLeft;
        const walk = (x - this.startX) * 1.2;
        this.viewport.scrollLeft = this.scrollLeftStart - walk;
      });
    }
  }

  customElements.define('collection-scroll-lg', CollectionScroll);
}
